import type { MainNavItem } from '@/features/manage/types';

export const manageBasePath = '/manage';

export const teamMemberRoles = ['admin', 'manager', 'manager:flashcards'] as const;

export type StaffRole = (typeof teamMemberRoles)[number];

export const mainNavList: MainNavItem[] = [
  {
    label: 'nav.dashboard',
    route: `${manageBasePath}/dashboard`,
    needsAuth: true,
    roles: ['manager:flashcards', 'manager', 'admin'],
  },
  {
    label: 'nav.users',
    route: `${manageBasePath}/users`,
    needsAuth: true,
    roles: ['manager', 'admin'],
  },
  {
    label: 'nav.courses',
    route: `${manageBasePath}/courses`,
    needsAuth: true,
    roles: ['manager', 'admin'],
  },
  {
    label: 'nav.units',
    route: `${manageBasePath}/units`,
    needsAuth: true,
    roles: ['manager', 'admin'],
  },
  {
    label: 'nav.exercises',
    route: `${manageBasePath}/exercises`,
    needsAuth: true,
    roles: ['manager', 'admin'],
  },
  {
    label: 'nav.questions',
    route: `${manageBasePath}/questions`,
    needsAuth: true,
    roles: ['manager', 'admin'],
  },
  {
    label: 'nav.flashcardDecks',
    route: `${manageBasePath}/flashcard-decks`,
    needsAuth: true,
    roles: ['manager', 'admin'],
  },
  {
    label: 'nav.flashcards',
    route: `${manageBasePath}/flashcards`,
    needsAuth: true,
    roles: ['manager:flashcards', 'manager', 'admin'],
  },
  {
    label: 'nav.announcements',
    route: `${manageBasePath}/announcements`,
    needsAuth: true,
    roles: ['manager', 'admin'],
  },
];
